import { Injectable } from '@angular/core';
import { routeContactPoint } from '@medlogic/shared/shared-interfaces';
import { FhirGenericService } from './fhir-generic.service';

@Injectable({ providedIn: 'root' })
export class FhirIContactPointService extends FhirGenericService {

  protected url = routeContactPoint;

}
